if (!customElements.get('sample-sale-gate')) {
  customElements.define(
    'sample-sale-gate',
    class SampleSaleGate extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.codeInput = this.querySelector('[data-access-code-input]');
        this.checkboxInput = this.querySelector('[data-terms-checkbox]');
        this.submitButton = this.querySelector('[data-submit-button]');
        this.errorMessage = this.querySelector('[data-error-message]');

        this.checkboxInput.addEventListener('change', this.onTermsChange.bind(this));
        this.codeInput.addEventListener('input', this.clearError.bind(this));
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onTermsChange() {
        this.submitButton.disabled = !this.checkboxInput.checked;
      }

      onSubmit(event) {
        event.preventDefault();

        const enteredCode = this.codeInput.value.trim();
        const validCode = (this.dataset.accessCode || '').trim();

        if (!enteredCode || !this.checkboxInput.checked || enteredCode !== validCode) {
          this.showError();
          return;
        }

        this.grantAccess();
      }

      showError() {
        this.errorMessage.hidden = false;
        this.codeInput.setAttribute('aria-invalid', 'true');
        this.codeInput.focus();
      }

      clearError() {
        this.errorMessage.hidden = true;
        this.codeInput.removeAttribute('aria-invalid');
      }

      grantAccess() {
        const secureFlag = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = `sample_sale_access=granted; path=/; SameSite=Lax${secureFlag}`;
        window.location.href = this.dataset.redirectUrl;
      }
    }
  );
}
